export const wrongTimeFormatError = 'Please use 12 hour AM/PM time format';
export const requiredFieldErrorMessage = 'Please fill in this field';
